if (!customElements.get('trust-bar-marquee')) {
  class TrustBarMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.trust-bar__track');
      this.list = this.querySelector('[data-trust-bar-list]');
      if (!this.track || !this.list) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => this.sync();
      this.reducedMotion.addEventListener('change', this.onMotionChange);

      this.resizeObserver = new ResizeObserver(() => this.sync());
      this.resizeObserver.observe(this);

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => this.sync());
      }

      this.sync();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.reducedMotion?.removeEventListener('change', this.onMotionChange);
    }

    contentWidth() {
      const items = this.list.querySelectorAll('.trust-bar__item');
      if (!items.length) return 0;

      const first = items[0].getBoundingClientRect();
      const last = items[items.length - 1].getBoundingClientRect();
      return last.right - first.left;
    }

    sync() {
      if (this._syncing) return;
      this._syncing = true;

      try {
        this.reset();

        const overflows = this.contentWidth() > this.clientWidth + 1;
        if (!overflows) return;

        if (this.reducedMotion.matches || window.matchMedia('(pointer: coarse)').matches) {
          this.classList.add('is-static-scroll');
          return;
        }

        this.enableMarquee();
      } finally {
        this._syncing = false;
      }
    }

    reset() {
      this.classList.remove('is-marquee', 'is-static-scroll');
      this.style.removeProperty('--trust-bar-shift');
      this.style.removeProperty('--trust-bar-duration');
      this.querySelectorAll('.trust-bar__list[aria-hidden="true"]').forEach((node) => node.remove());
    }

    enableMarquee() {
      const gap =
        Number.parseFloat(getComputedStyle(this).getPropertyValue('--trust-bar-gap')) || 0;
      const shift = Math.round(this.contentWidth() + gap);

      if (shift <= gap) {
        this.classList.add('is-static-scroll');
        return;
      }

      const clone = this.list.cloneNode(true);
      clone.removeAttribute('data-trust-bar-list');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      this.track.appendChild(clone);

      this.style.setProperty('--trust-bar-shift', `${shift}px`);
      this.style.setProperty('--trust-bar-duration', `${Math.max(12, shift / 40)}s`);
      this.classList.add('is-marquee');
    }
  }

  customElements.define('trust-bar-marquee', TrustBarMarquee);
}
